import React from "react";

function Blog() {
  return (
    <div className="general scroll">
      <h2>Blog Entry #1</h2>
      <p> The date is December fifth, 2023— we are near the year end.</p>
      <p> I am still seeking work in the tech industry as a web dev, and in the meantime I've kept myself busy with multiple projects when 
        I'm not working in the asbestos lab. I and some of my classmates from the coding bootcamp are collaborating in order to make a 
        Shopify page for one of their mother/sisters candle making shop. The other is... a kind of social media web app which is meant 
        to put people in touch with local farmers for people interested in their produce. That's all I have to say on that one for now. I 
        am also in the process of polishing cabochon gemstones for some of my coworkers and their family members. Needless to say, I'm 
        certainly keeping busy, and yet I'm quite satisfied with my progress. A year ago today I was starting to learn coding through 
        coursera classes, and now I am competent enough to be a hireable employee.</p>
        <p>P.S. To any hiring managers or recruiters reading this: Sorry if anything in this website seems incomplete. I consider my 
          portfolio to be one of the ways I keep practicing, and I have plans for some of the less developed sections of my portfolio. 
          If you see something that indicated content is coming soon, I might slip in a small game or something programmed in JS. That's 
          just one example of a current thought I have, though I still need to execute it.
        </p>
        <p> Anyway, enough excuses, back to programming,</p>
        <p> Best regards,</p>
        <p> Will Riffe</p>
    </div>
  );
}

export default Blog;
